import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'
export default {
    getReportsSummaries({ commit }, {
        paginate = '',
        query = ''
    } = {}) {
        commit('GET_REPORTS_SUMMARIES_REQUEST')

        return axios
            .get(`/reports/reports-user-efficiency-by-production-site${paginate}${query}`)
            .then(response => {
                commit('GET_REPORTS_SUMMARIES_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_REPORTS_SUMMARIES_FAILURE')
                handleApiError(error, 'Pobranie podsumowań nie powiodło się.')

                return Promise.reject(error)
            })
    },
    generateReportsSummariesReport({ commit }, {
        query = '',
        userEmail
    } = {}) {
        return axios
            .get(`/reports/reports-user-efficiency-by-production-site?report=true${query}`, {
                timeout: 120000, // 2 min
            })
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: `Raport został wysłany na adres ${userEmail}.`
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Wygenerowanie raportu nie powiodło się.')

                return Promise.reject(error)
            })
    },
    generateOrderStatusesReport({ commit }, orderStatusesReportData) {
        return axios
            .post('reports/report-orders-statuses', orderStatusesReportData)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: `Raport został wysłany na adres ${orderStatusesReportData['userEmail']}.`
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Wygenerowanie raportu nie powiodło się.')

                return Promise.reject(error)
            })
    },

    setReportsSummariesFilters({ commit }, filters) {
        commit('SET_REPORTS_SUMMARIES_FILTERS', filters)
    },
    clearReportsSummariesFilters({ commit }) {
        commit('CLEAR_REPORTS_SUMMARIES_FILTERS')
    },
}